module.exports = __webpack_public_path__ + "img/guertel.6eb7995d.svg";